var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("span", [_vm._v(_vm._s(_vm.output))]),
      _vm._v(" "),
      _vm.enableEllipsis
        ? [
            !_vm.isFull ? _c("span", [_vm._v(_vm._s(_vm.ellipsis))]) : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "more-less",
                on: {
                  click: function ($event) {
                    _vm.isFull = !_vm.isFull
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("utils." + (_vm.isFull ? "less" : "more")))
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }